/**
 * We operate a CDN that also can perform resize operations on MLS images.
 *
 * This utility class generates a CDN-based URL that will fetch the underlying image URL of the given size.
 *
 * All URLs generated by this function will be processed by our `thumbs-up` repo which runs as a cloud function and serves as origin source 
 * when these URLs are prexented to the CDN.
 *
 * This function also relies on the ENV:THUMBNAIL_URL as the CDN base url.
 *
 * @param src string the original url
 * @param size string|json `original` or `{ width: 123, height: 123 }` object format
 */
const parseUrl = uri => uri.match(/^(http|https)?:?\/\/(.*)/)

export default function getThumbnail(src, size = 'original') {
  if (typeof size === 'object') {
    const { width = '', w = width, height = '', h = height } = size
    size = `${w}x${h}`
  }

  if (!src) {
    src = 'http://images.showcaseidx.com/nophotos.png'
  }
/* eslint-disable no-unused-vars */
  let [_, scheme, url] = parseUrl(src)
/* eslint-enable no-unused-vars */
  var schemeDirPrefix = ''
  if (scheme === '' || scheme === 'https') {
    schemeDirPrefix = 's/'
  }

  const proxyUrl = `${process.env.THUMBNAIL_URL}/${schemeDirPrefix}${size}/${url}`

  return proxyUrl
}



// WEBPACK FOOTER //
// client/components/util/getThumbnail.js